if (!Number.prototype.round) {
    Number.prototype.round = function (decimalPoints) {
        if (typeof decimalPoints === "undefined") {
            return Math.round(this);
        }

        var multiplier = Math.pow(10, decimalPoints);

        return Math.round(this * multiplier) / multiplier;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/app/extensions/number.js
// module id = 436
// module chunks = 1